















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { JinroRoomDocument } from "@/services/datatypes";
import { ToastProgrammatic as Toast } from "buefy";
import { TOAST_DURATION_MILLISECONDS } from "@/services/constants";
import CopyCurrentUrlButton from "@/components/shared/CopyCurrentUrlButton.vue";
import QrButton from "@/components/shared/QrButton.vue";

@Component({
  components: {
    CopyCurrentUrlButton,
    QrButton,
  },
})
export default class ShareUrl extends Vue {
  @Prop() readonly jinroRoom!: JinroRoomDocument;
  get isOwner() {
    return (
      this.$store.state.firebaseUser &&
      this.jinroRoom!.owner === this.$store.state.firebaseUser.uid
    );
  }

  get currentUrl(): string {
    return window.location.href;
  }
}
